import Profile from "../../../pages/Profile";
import {getPXLProfileRoute} from "./factory/profile";

const routes = [
    {
        path: getPXLProfileRoute(),
        component: Profile,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;